import React from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { LanguageLoader } from "../../assets/languages";
import { GetSSRSReportAPI } from "../../services";
import { DownloadByContent } from "../utils";

const Linkable = ({field, value, customization={}}) => {
	const preferences = useSelector((state) => state.preferences);
	const language = LanguageLoader(preferences.language);
	const {module} = useParams();

	const FetchRahkaranReport = async (reportID) =>
	{
		GetSSRSReportAPI(reportID).then(response =>
		{
			if(response && response.content)
			{
				DownloadByContent(response.content, response.name);
			}
		});
	}
	
	if(module === 'Rahkaran_Reports' && field === 'execution')
	{
		return <span className='cursor-pointer hover:text-white bg-primary text-secondaryFont px-3 py-1 rounded' onClick={() => FetchRahkaranReport(value)}>{language.DOWNLOAD}</span>
	}
	return null;
}

export default Linkable;